// 08.06.2026 – Dynamische Lieferdatum-Berechnung (Werktage, kein Wochenende)
// Schreibt das Ergebnis in alle Elemente mit [data-delivery-estimate]
// Mehrsprachig: DE, FR, EN – Sprache wird aus <html lang="..."> ausgelesen

(function () {
  function addBusinessDays(date, days) {
    var d = new Date(date);
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }

  var lang = document.documentElement.lang || 'de';
  var locale = lang.startsWith('fr') ? 'fr-FR' : lang.startsWith('en') ? 'en-GB' : 'de-DE';

  var labels = {
    'de-DE': { prefix: 'Lieferung zwischen', connector: 'und' },
    'fr-FR': { prefix: 'Livraison entre le', connector: 'et le' },
    'en-GB': { prefix: 'Delivery between', connector: 'and' },
  };

  function formatDate(date) {
    return date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
  }

  var offsets = {
    0: [2, 3], // Sonntag / Dimanche / Sunday
    1: [2, 3], // Montag / Lundi / Monday
    2: [2, 3], // Dienstag / Mardi / Tuesday
    3: [2, 3], // Mittwoch / Mercredi / Wednesday
    4: [2, 3], // Donnerstag / Jeudi / Thursday
    5: [2, 3], // Freitag / Vendredi / Friday
    6: [2, 3], // Samstag / Samedi / Saturday
  };

  function render() {
    var today = new Date();
    var dow = today.getDay();
    var pair = offsets[dow];
    var startDate = addBusinessDays(today, pair[0]);
    var endDate   = addBusinessDays(today, pair[1]);
    var l = labels[locale];
    var html = l.prefix + ' '
      + '<span style="color:#29a329;font-weight:600;">' + formatDate(startDate) + '</span>'
      + ' ' + l.connector + ' '
      + '<span style="color:#29a329;font-weight:600;">' + formatDate(endDate) + '</span>';
    document.querySelectorAll('[data-delivery-estimate]').forEach(function(el) {
      el.innerHTML = html;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
